module.exports = __webpack_public_path__ + "static/img/0764.7409374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0764.jpg
// module id = 103
// module chunks = 0